import React, { useEffect, useState } from "react";
import {
  subscribeToPush,
  unsubscribeFromPush,
  getExistingPushSubscription,
} from "../push";
import { getActiveBranch } from "../apiBase";
import { useAuth } from "../context/AuthContext";

export default function PushNotificationToggle() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  let auth = null;
  try {
    auth = typeof useAuth === "function" ? useAuth() : null;
  } catch (_) {
    auth = null;
  }

  const userEmail =
    auth?.user?.email ||
    auth?.email ||
    localStorage.getItem("userEmail") ||
    localStorage.getItem("user_email") ||
    localStorage.getItem("email") ||
    "";

  const role =
    auth?.user?.role ||
    auth?.role ||
    localStorage.getItem("role") ||
    localStorage.getItem("userRole") ||
    "";

  useEffect(() => {
    let mounted = true;

    async function checkStatus() {
      try {
        const sub = await getExistingPushSubscription();
        if (mounted) setEnabled(!!sub);
      } catch {
        if (mounted) setEnabled(false);
      }
    }

    checkStatus();

    return () => {
      mounted = false;
    };
  }, []);

  async function handleToggle() {
    if (loading) return;

    setLoading(true);

    try {
      if (!enabled) {
        const branch =
          typeof getActiveBranch === "function" ? getActiveBranch() : null;

        const isAdmin = String(role).toLowerCase() === "admin";

        await subscribeToPush({
          branch: branch || null,
          userEmail: userEmail || null,
          deviceLabel: "phone-browser",
          targetRole: role || null,
          isAdmin,
        });

        setEnabled(true);
      } else {
        await unsubscribeFromPush();
        setEnabled(false);
      }
    } catch (err) {
      alert(err?.message || "Failed to update notification setting.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleToggle}
      disabled={loading}
      title={enabled ? "Disable phone notifications" : "Enable phone notifications"}
      aria-pressed={enabled}
      className={`push-toggle ${enabled ? "on" : "off"} ${loading ? "loading" : ""}`}
    >
      <span className="push-toggle-label">
        {loading ? "..." : enabled ? "🔔 ON" : "🔕 OFF"}
      </span>
      <span className="push-toggle-track">
        <span className="push-toggle-thumb" />
      </span>
    </button>
  );
}